// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";

const metadata: BuiltInScriptMetadata = {
  name: "Heal",
  id: "heal",
  metadata: {
    imports: ["self","heal"],
    icon: {
      "backgroundColor": 1260324,
      "layers": [
        {
          "iconKey": "healing",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": 13,
          "color": 59269
        }
      ]
    },
  },
};

export default metadata;
